import type { TFunction } from "i18next";

import type { SubscriptionTableColumn, SubscriptionTableRow } from "../../SubscriptionTable/types";

export const getSubscriptionTableColumns = (t: TFunction, isEditable: boolean = true): SubscriptionTableColumn[] => [
    {
        id: "title",
        label: t("Titles.Title"),
        width: "180px",
        align: "left",
        render: (value: string, row: SubscriptionTableRow) => (
            <div>
                <div style={{ fontWeight: 500, fontSize: "11px" }}>{value}</div>
                <div
                    style={{
                        fontSize: "11px",
                        color: "#666",
                        marginTop: "2px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {row.subtitle}
                </div>
            </div>
        ),
    },
    {
        id: "consumptionCount",
        label: t("Subscription.NumberOfDownloads"),
        width: "12%",
        align: "center",
        editable: isEditable,
    },
    {
        id: "avgConsumptionDuration",
        label: t("Subscription.AverageConsumptionTime"),
        width: "13%",
        align: "center",
        editable: isEditable,
    },
    {
        id: "coefficient",
        label: t("Subscription.Coefficient"),
        width: "10%",
        align: "center",
        editable: false,
        render: (value: number, row: SubscriptionTableRow) => (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <span style={{ color: "#999", fontSize: "11px" }}>{value}</span>
                {row.correctiveFactor && row.correctiveFactor !== 1 && (
                    <span style={{ color: "#999", fontSize: "11px", marginTop: "2px" }}>
                        x{Math.round(row.correctiveFactor * 1000) / 1000}
                    </span>
                )}
            </div>
        ),
    },
    {
        id: "totalConsumptionTime",
        label: t("Subscription.TotalConsumptionTime"),
        width: "13%",
        align: "center",
        highlighted: true,
        render: (value: number) => <span style={{ fontWeight: 500, fontSize: "11px" }}>{value.toFixed(2)}</span>,
    },
    {
        id: "totalOfAllItems",
        label: t("Subscription.TotalOfAllItems"),
        width: "12%",
        align: "center",
        highlighted: true,
        render: (value: number) => <span style={{ fontWeight: 500, fontSize: "11px" }}>{value.toFixed(2)}</span>,
    },
    {
        id: "revenueShare",
        label: t("Subscription.RevenueShareOfItem"),
        width: "13%",
        align: "center",
        highlighted: true,
        render: (value: number) => <span style={{ fontWeight: 500, fontSize: "11px" }}>{value.toFixed(2)}€</span>,
    },
    {
        id: "royalties",
        label: t("Subscription.RoyaltiesAmount"),
        width: "20%",
        align: "center",
        render: (value: any[]) => {
            if (!value || value.length === 0) return <span>-</span>;
            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        fontSize: "11px",
                        lineHeight: "1.4",
                        gap: "8px",
                    }}
                >
                    {value.map((royalty) => {
                        const beneficiaryFullName =
                            royalty.beneficiaryName && royalty.beneficiarySurname
                                ? `${royalty.beneficiaryName} ${royalty.beneficiarySurname}`.trim()
                                : royalty.beneficiaryName || royalty.beneficiarySurname || null;

                        return (
                            <div key={royalty.termId} style={{ marginBottom: "4px" }}>
                                <div style={{ fontWeight: 500, marginBottom: "2px" }}>
                                    {beneficiaryFullName || `Term ${royalty.termId}`}
                                </div>
                                {royalty.valuesByPeriod &&
                                    Object.entries(royalty.valuesByPeriod).map(([periodId, values]: [string, any]) => (
                                        <div key={periodId} style={{ marginLeft: "8px", marginBottom: "1px" }}>
                                            {`${values.percentage}% -> ${values.amount.toFixed(2)}€`}
                                        </div>
                                    ))}
                            </div>
                        );
                    })}
                </div>
            );
        },
    },
];
